export default __webpack_public_path__ + "static/BNGTransparent-948c79c7dcfb625a6d0395ad0e8463e2.png";